import React, { useState, useContext, useEffect } from "react";
import { Nav, Tab } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { ThemeContext } from "../../context/ThemeContext";
import { useSettings } from "../../context/SettingsContext";
import { updateSiteSettings } from "../../store/custom-actions/settings-actions/siteSettingsSlicer";
import ColorPicker from "../components/ui/ColorPicker";

const Setting = () => {
  const dispatch = useDispatch();
  const { getSetting, settings } = useSettings();
  const { changePrimaryColor, changeSecondaryColor } = useContext(ThemeContext);
  const { loading: settingsLoading } = useSelector(
    (state) => state.siteSettingsSlicer
  );

  const [settingToggle, setSettingToggle] = useState(false);

  // === Site color states ===
  const [dashboardPrimaryColor, setDashboardPrimaryColor] = useState();
  const [dashboardSecondaryColor, setDashboardSecondaryColor] = useState();
  const [userPanelPrimaryColor, setUserPanelPrimaryColor] = useState();
  const [userPanelsecondaryColor, setUserPanelSecondaryColor] = useState();
  const [userPanelPrimaryHover, setUserPanelPrimaryHover] = useState();

  // === Load settings on mount ===
  useEffect(() => {
    if (settings) {
      setDashboardPrimaryColor(getSetting("back_primary_color"));
      setDashboardSecondaryColor(getSetting("back_secondary_color"));
      setUserPanelPrimaryColor(getSetting("front_primary_color"));
      setUserPanelSecondaryColor(getSetting("front_secondary_color"));
      setUserPanelPrimaryHover(getSetting("front_primary_color_hover"));
    }
  }, [settings]);

  // === Submit colors to backend ===
  const handleSubmitData = () => {
    dispatch(
      updateSiteSettings({
        back_primary_color: dashboardPrimaryColor,
        back_secondary_color: dashboardSecondaryColor,
        front_primary_color: userPanelPrimaryColor,
        front_secondary_color: userPanelsecondaryColor,
        front_primary_color_hover: userPanelPrimaryHover,
      })
    );
  };

  // === Reusable color picker handler ===
  const handleColorChange = (setter, changer) => (value) => {
    if (changer) changer(value);
    setter(value);
  };

  // === Color palette ===
  const colorOptions = [
    { name: "color_1", color: "#FF6Aaa" },
    { name: "color_2", color: "#49bb98" },
    { name: "color_3", color: "#FF6A59" },
    { name: "color_4", color: "#ff965f" },
    { name: "color_5", color: "#3250ff" },
    { name: "color_6", color: "#3f8cff" },
    { name: "color_7", color: "#40a7e2" },
    { name: "color_8", color: "#b65fbd" },
    { name: "color_9", color: "#88a67e" },
    { name: "color_10", color: "#6759d1" },
    { name: "color_11", color: "#c6164f" },
    { name: "color_12", color: "#343a40" },
    { name: "color_13", color: "#2a2a2a" },
    { name: "color_14", color: "#4885ed" },
    { name: "color_15", color: "#4cb32b" },
  ];

  return (
    <div
      className={`sidebar-right ${settingToggle ? "show" : ""}`}
      style={{ zIndex: 999999999 }}
    >
      <div className="bg-overlay" onClick={() => setSettingToggle(false)} />

      {/* Open Button */}
      <Link
        to="#"
        className="sidebar-right-trigger z-[9999999999999] wave-effect wave-effect-x bg-primary"
        onClick={() => setSettingToggle(!settingToggle)}
      >
        <i className="fa fa-cog fa-spin" />
      </Link>

      {/* Close Button */}
      <Link
        to="#"
        className="sidebar-close-trigger z-[9999999999999]"
        onClick={() => setSettingToggle(false)}
      >
        <i className="la-times las" />
      </Link>

      <div className="sidebar-right-inner">
        <h4>Pick your style</h4>

        <Tab.Container defaultActiveKey="Theme">
          <div className="card-tabs">
            <Nav as="ul" className="nav nav-tabs" role="tablist">
              <Nav.Item as="li" className="nav-item">
                <Nav.Link
                  as="a"
                  className="nav-link c-pointer"
                  eventKey="Theme"
                >
                  Dashboard
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li" className="nav-item">
                <Nav.Link
                  as="a"
                  className="nav-link c-pointer"
                  eventKey="Header"
                >
                  User Panel
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>

          <Tab.Content className="mt-3">
            {/* Save Button */}
            <div className="row mb-3">
              <div className="col-sm-12">
                <button
                  type="submit"
                  className="btn btn-primary sw-btn-next ms-1"
                  onClick={handleSubmitData}
                  disabled={settingsLoading}
                >
                  {settingsLoading ? "Loading..." : "Save Changes"}
                </button>
              </div>
            </div>

            {/* Theme Settings */}
            <Tab.Pane eventKey="Theme">
              <div className="admin-settings row">
                <ColorPicker
                  label="Primary Color"
                  colors={colorOptions}
                  selectedColor={dashboardPrimaryColor}
                  setSelectedColor={handleColorChange(
                    setDashboardPrimaryColor,
                    changePrimaryColor
                  )}
                  inputName="theme_primary"
                  disabled={settingsLoading}
                />
                <ColorPicker
                  label="Secondary Color"
                  colors={colorOptions}
                  selectedColor={dashboardSecondaryColor}
                  setSelectedColor={handleColorChange(
                    setDashboardSecondaryColor,
                    changeSecondaryColor
                  )}
                  inputName="theme_secondary"
                  disabled={settingsLoading}
                />
              </div>
            </Tab.Pane>

            {/* User Panel Settings */}
            <Tab.Pane eventKey="Header">
              <div className="admin-settings row">
                <div className="col-sm-12 mt-3">
                  <span className="text-danger">*Note :</span> When choosing
                  User Panel Colors, refresh the page after submitting to see
                  changes applied.
                </div>

                <ColorPicker
                  label="User Panel Primary Color"
                  colors={colorOptions}
                  selectedColor={userPanelPrimaryColor}
                  setSelectedColor={setUserPanelPrimaryColor}
                  inputName="user_primary"
                  disabled={settingsLoading}
                />

                <ColorPicker
                  label="User Panel Secondary Color"
                  colors={colorOptions}
                  selectedColor={userPanelsecondaryColor}
                  setSelectedColor={setUserPanelSecondaryColor}
                  inputName="user_secondary"
                  disabled={settingsLoading}
                />

                <ColorPicker
                  label="User Panel Primary Hover"
                  colors={colorOptions}
                  selectedColor={userPanelPrimaryHover}
                  setSelectedColor={setUserPanelPrimaryHover}
                  inputName="user_primary_hover"
                  disabled={settingsLoading}
                />
              </div>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </div>
  );
};

export default Setting;
